import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { AdvancedMarker, APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
//components
import PublicMap from "./Map";
//services
import { getGoogleMap } from "../../services/Settings/GoogleMaps/getGoogleMap";
//context
import { useAppContext } from "../../context/AppContext";
import { useMapContext } from "../../context/MapContext";

const PublicGoogleMap = () => {
  const { hash } = useParams();
  const { googleMapsPosition, setGoogleMapsPosition } = useMapContext();
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [notConfigured, setNotConfigured] = useState(false);
  const navigate = useNavigate();
  const { context, permissions } = useAppContext();
  const mapRef = useRef("GoogleMapsView");

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
  }, [context]);

  const { data, isLoading } = useQuery({
    queryKey: [`google-map${hash}`],
    queryFn: () => getGoogleMap(hash),
    retry: false
  });

  useEffect(() => {
    if (data && Object.keys(data).length !== 0) {
      setGoogleMapsPosition({
        lat: parseFloat(data?.lat),
        lng: parseFloat(data?.lng),
      });
      setRotation(parseFloat(data?.radius_circle));
      setNotConfigured(false);
    } else if ((!data || Object.keys(data).length === 0) && !isLoading) {
      setNotConfigured(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  const updateZoom = (e) => {
    setZoom(e.detail?.zoom);
  };

  return (
    <>
      <APIProvider
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["marker"]}
      >
        <Map
          style={{ width: "100%", height: "90vh" }}
          mapId={"6d1d89abc5b23d2e"}
          defaultZoom={16}
          onZoomChanged={updateZoom}
          defaultCenter={googleMapsPosition}
          gestureHandling={"cooperative"}
          mapTypeId={"hybrid"}
          ref={mapRef}
          disableDefaultUI
          disableDoubleClickZoom
        >
          <AdvancedMarker
            position={googleMapsPosition}
            title={"Empreendimento no Mapa do Google Maps."}
            style={{
              position: "relative",
              width: "200px", // Defina o tamanho fixo desejado
              height: "200px",
              transform: `rotate(${rotation}deg)`,
              overflow: "visible",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <PublicMap type="google" empId={hash} />
            </div>
            {zoom && zoom <= 12 && <Marker position={googleMapsPosition} />}
          </AdvancedMarker>
        </Map>
      </APIProvider>
    </>
  )
};

export default PublicGoogleMap;
